import { getGLobalRepoUrl } from "./api-services";
import axios from "axios";
import urls from "./urls";

const baseUrl = getGLobalRepoUrl(`/${urls.presentation}`);
const presentationsUrl = getGLobalRepoUrl(urls.presentations);
const folderPresentationUrl = getGLobalRepoUrl(urls.folderPresentation);
const presentationDocumentUrl = getGLobalRepoUrl(urls.presentationDoc);

export const getAllPresentations = (payload, pageableParams = {}) => {
  return axios.post(presentationsUrl, payload, { params: pageableParams });
};

export const getPresentationById = (id) => axios.get(`${baseUrl}/${id}`);

export const addPresentation = (data) => axios.post(baseUrl, data);

export const updatePresentation = (data) => axios.put(baseUrl, data);

export const deletePresentation = (id) => axios.delete(`${baseUrl}/${id}`);

export const getAllPresentationFolderByUserId = (userId) => {
  return axios.get(`${folderPresentationUrl}/allfolders?userId=${userId}`);
};

export const getPresentationByFolder = (params, body = {}) => {
  return axios.post(`${folderPresentationUrl}/getpresentationbyfolder`, body, {
    params,
  });
};

export const addPresentationDocument = (data) => {
  return axios.post(presentationDocumentUrl, data);
};

export const getPresentationDocuments = (presentationId, pageableParams = {}) => {
  return axios.get(presentationDocumentUrl, {
    params: {
      presentationid: presentationId,
      ...pageableParams,
    },
  });
};

export const uploadPresentationDocument = (presentationId, data) => {
  return axios.post(`${presentationDocumentUrl}/upload`, data, {
    params: {
      presentationid: presentationId,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deletePresentationDocument = (id) => {
  return axios.delete(`${presentationDocumentUrl}/${id}`);
};

export const uploadPresentationPpt = (data) => {
  return axios.post(`${baseUrl}/ppt/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const savePresentationPptFile = (data) => axios.post(`${baseUrl}/ppt/file`, data);

export const getPresentationPptFilesByFact = (params = {}) => axios.get(`${baseUrl}/ppt/file/all`, {
  params,
});

export const notifyPresentationPptFilesFact = (data) => axios.put(`${baseUrl}/ppt/file/multiple`, data);

export const convertPresentationPptSlides = (filePath, presentationId, pptFileId) => {
  return axios.post(`${baseUrl}/pptslides`, { filePath }, {
    params: {
      presentationid: presentationId,
      pptFileId,
    },
  });
};

export const getPresentationSlides = (presentationId, pageableParams = {}) => {
  return axios.get(`${folderPresentationUrl}/${presentationId}/slides`, {
    params: pageableParams,
  });
};

export const updatePresentationSlideOrder = (presentationId, slideOrders) => {
  return axios.put(`${folderPresentationUrl}/${presentationId}/slides/order`, slideOrders);
};

export const deletePresentationSlide = (presentationId, slideId) => {
  return axios.delete(`${folderPresentationUrl}/${presentationId}/slides/${slideId}`);
};
